import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

import { register } from "../redux/actions/authActions";
import signup from "../assets/img/account/signup.png";
import Header from "../home/components/Header";

const Signup = ({ register }) => {
  const navigate = useNavigate();
  const { refid } = useParams();

  console.log("Referred By :", refid);

  const [referralId, setReferralId] = useState(refid || "LB101010");
  const [referrerName, setReferrerName] = useState("");
  const [isRequest, setIsRequest] = useState(false);
  const [isLoadingReferrer, setIsLoadingReferrer] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirm_pass: "",
    referred_by: refid || "LB101010",
  });

  const [redirect, setRedirect] = useState(false);

  // Get base API URL from environment or use relative path
  const API_BASE_URL = process.env.REACT_APP_API_URL || "";

  // Fetch referrer's name when refid is available
  useEffect(() => {
    const fetchReferrerName = async () => {
      if (refid) {
        setIsLoadingReferrer(true);
        try {
          setReferralId(refid);
          setFormData((prevFormData) => ({
            ...prevFormData,
            referred_by: refid,
          }));

          // ✅ FULL API PATH

          const apiUrl = `https://api.bitautobot.com/auth/user/referrer/${refid}` || `http://localhost:4000/auth/user/referrer/${refid}`;
          
          console.log("🔄 Fetching referrer from:", apiUrl);          
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          console.log("📡 Response status:", response.status);
          
          if (response.ok) {
            const data = await response.json();
            console.log("✅ Referrer data:", data);
            setReferrerName(data.name || "Referrer");
          } else {
            console.log("❌ Response not OK");
            setReferrerName("Referrer");
          }
        } catch (error) {
          console.error("❌ Error fetching referrer name:", error);
          setReferrerName("Referrer");
        } finally {
          setIsLoadingReferrer(false);
        }
      } else {
        // If no refid, set default values
        setReferrerName("System");
      }
    };

    fetchReferrerName();
  }, [refid, API_BASE_URL]);

  const { name, email, password, confirm_pass } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsRequest(true);
    
    if (password !== confirm_pass) {
      setIsRequest(false);
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setIsRequest(false);
      toast.error("Password must be at least 6 characters");
      return;
    }

    register(
      { 
        name, 
        email, 
        password, 
        referred_by: formData.referred_by 
      },
      (success) => {
        if (success) {
          setRedirect(true);
          toast.success("Registration successful! Please check your email for verification.");
        } else {
          setIsRequest(false);
        }
      }
    );
  };

  if (redirect) {
    return <Navigate to="/verify-email" />;
  }

  return (
    <div>
      <Header />
      
      {/* Banner Section */}
      <div className="page-banner-wrap text-capitalize">
        <div className="container">
          <div className="row">
            <div className="col-12 col-xl-6 ps-xl-0 pe-xl-0 offset-xl-3 col-lg-8 offset-lg-2 text-center text-white">
              <div className="page-heading">
                <h1>Sign Up</h1>
              </div>
              <nav aria-label="breadcrumb">
                <ul className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sign Up
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Signup Section */}
      <div className="account section-padding">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <div className="account__wrapper">
                <h3 className="title">Create Your Account</h3>
                
                {/* Referrer Information */}
                {refid && (
                  <div className="mb-4">
                    <div className="card bg-warning border-success">
                      <div className="card-body py-3">
                        <h6 className="card-title mb-2 d-flex align-items-center">
                          <span className="me-2">👤</span>
                          Referred By
                        </h6>
                        <div className="row">
                          <div className="col-6">
                            <small className="text-muted">Referral ID</small>
                            <p className="mb-0 fw-bold">{referralId}</p>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">Name</small>
                            {isLoadingReferrer ? (
                              <p className="mb-0">
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Loading...
                              </p>
                            ) : (
                              <p className="mb-0 fw-bold text-dark">
                                {referrerName}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <form className="account__form" onSubmit={onSubmit}>
                  <div className="form-floating mb-4">
                    <input
                      name="name"
                      type="text"
                      className="form-control"
                      placeholder="Please Enter Your Name"
                      value={name}
                      onChange={onChange}
                      required
                      minLength="2"
                    />
                    <label htmlFor="floatingInput-user">Full Name</label>
                  </div>

                  <div className="form-floating mb-4">
                    <input
                      name="email"
                      type="email"
                      className="form-control"
                      placeholder="Please Enter Valid Email Address"
                      value={email}
                      onChange={onChange}
                      required
                    />
                    <label htmlFor="floatingInput">Email Address</label>
                  </div>

                  <div className="form-floating mb-4">
                    <input
                      type="password"
                      name="password"
                      placeholder="Please Enter Strong Alpha Numeric Password"
                      value={password}
                      onChange={onChange}
                      className="form-control"
                      required
                      minLength="6"
                    />
                    <label htmlFor="floatingPassword">Password</label>
                    <div className="form-text">
                      Password must be at least 6 characters long
                    </div>
                  </div>

                  <div className="form-floating mb-4">
                    <input
                      type="password"
                      name="confirm_pass"
                      placeholder="Confirm Password as per above field"
                      value={confirm_pass}
                      onChange={onChange}
                      className="form-control"
                      required
                      minLength="6"
                    />
                    <label htmlFor="floatingPassword2">Confirm Password</label>
                  </div>

                  {/* Hidden referral field */}
                  <input
                    type="hidden"
                    name="referred_by"
                    value={formData.referred_by}
                  />

                  <div className="form-group">
                    <div className="d-flex justify-content-between flex-wrap pt-sm-2">
                      <div className="checkgroup">
                        <input 
                          type="checkbox" 
                          name="remember" 
                          id="remember" 
                          required 
                        />
                        <label htmlFor="remember">
                          I accept the Terms & Conditions and Privacy Policy
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    {!isRequest ? (
                      <button
                        type="submit"
                        className="d-block custom-btn move-top w-100"
                      >
                        Create Account
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="d-block custom-btn move-top w-100"
                        disabled
                      >
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Creating Account...
                      </button>
                    )}
                  </div>
                </form>

                <div className="account-bottom text-center">
                  <p className="d-block cate pt-3">
                    Already have an account?{" "}
                    <a href="/signin" className="text-primary fw-bold">
                      Sign In
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="account-img text-center">
                <img src={signup} alt="account vector" className="img-fluid" />
                <div className="mt-4">
                  <h5 className="text-primary">Join Our Community</h5>
                  <p className="text-muted">
                    Start your journey with us and unlock amazing opportunities for growth and success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Signup.propTypes = {
  register: PropTypes.func.isRequired,
};

export default connect(null, { register })(Signup);